import React from "react";

export default function Table_Pivot_Intro() {
  return <div>Excel_Table_Pivot_Intro</div>;
}
